@if (inputService.formGroup) {
  <section class="areas" [class.areas--idle]="!moduleEnabled" [formGroup]="inputService.formGroup" aria-labelledby="assistant-areas-title">
    <h3 id="assistant-areas-title" class="areas__title">{{'Dove lavora l\'assistente' | translate}}</h3>
    @if (!moduleEnabled) {
      <p class="areas__note">{{'Le sezioni valgono quando l\'assistente è attivo.' | translate}}</p>
    }

    @for (group of groups; track group.name) {
      @if (group.areas.length) {
        <div class="group" role="group" [attr.aria-label]="group.name | translate">
          <div class="group__head">
            <mat-icon class="group__icon" aria-hidden="true">{{group.icon}}</mat-icon>
            <span class="group__name">{{group.name | translate}}</span>
            <span class="group__count" [class.group__count--none]="!activeCount(group)">
              @if (activeCount(group)) {
                {{activeCount(group)}} {{'di' | translate}} {{group.areas.length}} {{'attive' | translate}}
              } @else {
                {{'Nessuna attiva' | translate}}
              }
            </span>
          </div>

          @for (area of group.areas; track area.key) {
            <div class="area">
              <div class="area__text">
                <span class="area__name" [id]="'assistant-area-' + area.key">{{area.name | translate}}</span>
                <span class="area__description" [id]="'assistant-area-desc-' + area.key">{{area.description | translate}}</span>
                <span class="area__where">{{'Compare in' | translate}}: {{area.where | translate}}</span>
              </div>
              <mat-slide-toggle class="area__toggle"
                [formControlName]="area.key"
                [aria-labelledby]="'assistant-area-' + area.key"
                [aria-describedby]="'assistant-area-desc-' + area.key">
              </mat-slide-toggle>
            </div>
          }

          @if (!activeCount(group)) {
            <p class="group__empty">{{'Nessuna sezione attiva: l\'assistente non compare in queste schermate.' | translate}}</p>
          }
        </div>
      }
    }
  </section>
}
